const DEP_ENV = process.env.REACT_APP_DEP
const VERSION = '0.0.1'

function isFunction(value) {
  return !!value && typeof value === 'function'
}

const openUrl = (value) => {
  if ([4, '4'].includes(value.navType)) {
    document.location.href = value.url
  }
  if ([2, '2'].includes(value.navType)) {
    window.open(value.url)
  }
}

const evalCode = (code, params = {}) => {
  params.utils = {
    version: VERSION,
    env: DEP_ENV,
    // Toast,
  }

  let fn
  try {
    const wrCode = `fn=${code}`
    // eslint-disable-next-line no-eval
    eval(wrCode)
    if (isFunction(fn)) {
      return fn(params)
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

const evalHandleCode = (code) => {
  let fn
  try {
    const wrCode = `fn=${code}`
    // eslint-disable-next-line no-eval
    eval(wrCode)
    if (isFunction(fn)) {
      return { handleData: fn }
    }
  } catch (error) {
    console.log(error)
  }
  return {}
}

export const defaultEvents = {
  default: (value, opts, params) => {
    if (value && value.url && value.url.length > 0) {
      openUrl(value)
      return
    }
    const code = (value && value.code) || opts.code
    if (code && code.length > 0) {
      evalCode(code, params)
    }
  },
}

export const handleEvent = (value, opts, params, events) => {
  const { slug } = opts
  if (events && isFunction(events[slug])) {
    console.log('执行自定义事件')
    try {
      return events[slug](value, opts, params)
    } catch (error) {
      console.log(error)
    }
  } else {
    console.log('执行默认事件', value)
    defaultEvents.default(value, opts, params)
  }
  return null
}

// 处理显示的内容
const getValue = (val, opts) => {
  let value = val
  if (!val) {
    value = opts.default || {}
  }
  value.title = value.title || value.buttonName
  value.styleCode = opts.styleCode || value.styleCode
  value.handleCode = opts.dataCalDescribe
  return value
}

export const handleBtnValue = (val, opts, params) => {
  const value = getValue(val, opts)
  const { styleCode, handleCode } = value
  let props = { ...value }
  if (styleCode && styleCode.length > 0) {
    props = Object.assign(props, evalCode(styleCode, params) || {})
  }

  if (handleCode && handleCode.length > 0) {
    props = Object.assign(props, evalHandleCode(handleCode) || {})
  }

  return props
}
